import BaseModel from './BaseModel';

export default class ObjectType extends BaseModel {
    constructor(data = {}) {
        super(data);
        this.setData(data)
    }

    setData(data = this.__data__) {
        this.id = data.id;
        this.localId = data.id;
        this.name = data.name || this.translate.name || undefined;
        this.description = data.description || this.translate.description || undefined;
        this.code = data.code || this.translate.code || undefined;
        this.isAvailable = data.isAvailable || this.translate.isAvailable || false;
        this.types = data.types || [];
        this.createdDate = data.createdDate || undefined;
        this.originalPrice = data.originalPrice || 0;
        this.salePrice = data.salePrice || 0;
        this.multiple = data.multiple || 1;
        this.objectType = data.objectType || undefined;
        this.allowDelete = data.allowDelete || undefined;
        this.objectTypeId = data.objectTypeId || undefined;
        this.isDeleted = data.isDeleted || undefined;
        this.isDefault = data.isDefault || undefined;
        this.rateCodeId = data.rateCodeId || undefined;
        this.rateCode = data.rateCode || undefined;
        this.percentDiscount = data.percentDiscount || undefined;
        this.surchargeCategories = data.surchargeCategories || [];
        this.surchargeCategoryIds = data.surchargeCategoryIds || undefined;
        this.minQuantity = data.minQuantity || 1;
        this.maxQuantity = data.maxQuantity || 0;
        this.isEnableListing = data.isEnableListing || false;
        this.tourTicketProductItems = data.tourTicketProductItems || [];
        this.personPerTicket = data.personPerTicket || 0;
        this.rateCodeType = data.rateCodeType;
        this.isCombo = data.isCombo;
        this.objectTypeCombo = data.objectTypeCombo || [];
    }

    export(hasTranslate = false) {
        const result = super.export({
            id: this.id,
            name: this.name,
            objectTypeId: this.objectTypeId,
            description: this.description,
            code: this.code,
            isAvailable: this.isAvailable,
            types: this.types,
            originalPrice: this.originalPrice,
            salePrice: this.salePrice,
            multiple: this.multiple,
            isDeleted: this.isDeleted,
            isDefault: this.isDefault,
            rateCodeId: this.rateCodeId,
            rateCode: this.rateCode,
            percentDiscount: this.percentDiscount,
            surchargeCategoryIds: this.surchargeCategoryIds,
            minQuantity: this.minQuantity || 1,
            maxQuantity: this.maxQuantity || 0,
            isEnableListing: this.isEnableListing || false,
            rateCodeType: this.rateCodeType,
            isCombo: this.isCombo,
            objectTypeCombo: this.objectTypeCombo || [],
            tourTicketProductItems: (this.tourTicketProductItems || []).map(ttpItem => {
              const { localId, ...restTTPItem} = ttpItem
              return restTTPItem
            }),
            personPerTicket: this.personPerTicket || 0,
        });
        if (hasTranslate) result.translate = () => {
            
            return {
                id: this.translate.id,
                objectTypeId: this.translate.objectTypeId || this.objectTypeId || this.id,
                name: this.name,
                description: this.description,
                code: this.code,
                isAvailable: this.isAvailable,
                languageCode: this.languageCode,
                isDeleted: this.isDeleted,
                multiple: this.multiple
            }
        }
        return result;
    }

}
